module.exports = __webpack_public_path__ + "img/sister.564d7998.jpg";